import { LBButton, LBMsTeamsIcon } from '@linearb/buzz';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const MsTeamsConnectButton = ({
  clientId = '',
  ButtonText: buttonText = ''
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isCollaborationSensorsFeaturesEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isCollaborationSensorsFeaturesEnabled
  });

  // Don't render if collaboration sensors features are disabled
  if (!isCollaborationSensorsFeaturesEnabled) {
    return null;
  }

  return (
    <LBButton asChild variant='outline'>
      <a href={clientId} target='_blank'>
        <LBMsTeamsIcon />
        {buttonText}
      </a>
    </LBButton>
  );
};

export default MsTeamsConnectButton;
